export default "__VITE_ASSET__f5af5eb7__"